import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { BudgetComponent } from './components/budget/budget/budget.component';
import { RtbComponent } from './components/rtb/rtb/rtb.component';
import { DealerSettingsComponent } from './components/dealer/dealer-settings';
import { DashboardComponent } from './components/dashboard/dashboard/dashboard';
const appRoutes: Routes = <Routes>[
    { path: '', component: HomeComponent },
    { path: 'budget', component: BudgetComponent },
    { path: 'rtb', component: RtbComponent },
    { path: 'dealer', component: DealerSettingsComponent },
    { path: 'dashboard', component: DashboardComponent },
    { path: '**', redirectTo: '/', pathMatch: 'full' }
];
@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRouter { }


// WEBPACK FOOTER //
// ./src/app/app.router.ts